import { useEffect, useRef, useState } from "react";
import { animate, motion, useInView } from "framer-motion";

const STATS = [
  { value: 150, prefix: "+", suffix: "", label: "Projetos Entregues" },
  { value: 5, prefix: "+", suffix: "", label: "Anos de Experiência" },
  { value: 1500, prefix: "+", suffix: " ha", label: "Área Mapeada" },
  { value: 200, prefix: "+", suffix: "", label: "Clientes Atendidos" },
];

function Counter({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.9,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return <span ref={ref}>{display.toLocaleString("pt-BR")}</span>;
}

export default function Stats() {
  return (
    <section id="trajetoria" className="relative py-24 lg:py-28 border-y border-white/[0.06] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-deep via-ink to-deep" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.6 }}
            className="font-mono text-xs uppercase tracking-[0.32em] text-dm-contour"
          >
            Nossa Trajetória
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ delay: 0.1, duration: 0.7 }}
            className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white"
          >
            Inúmeros serviços realizados com máxima precisão
          </motion.h2>
        </div>

        <div
          data-testid="stats-grid"
          className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06] rounded-2xl overflow-hidden border border-white/[0.06]"
        >
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="bg-ink/80 px-6 py-10 lg:py-14 text-center"
            >
              <p className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
                <span className="text-dm-glow">{s.prefix}</span>
                <Counter value={s.value} />
                {s.suffix && <span className="text-dm-glow">{s.suffix}</span>}
              </p>
              <p className="mt-3 text-xs lg:text-sm uppercase tracking-[0.18em] text-slate-400">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
